// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1biRg_il_0nTk0JWVR4UIL","rotation":"_2YaptwvIBIXtiLdVue88Tx"};